import {createAsyncThunk} from '@reduxjs/toolkit'

import {ROUTER_ORDER_DETAIL} from '@web/core/routes'
import {browserAlert, changeBrowserLocation} from '@web/helpers/browser'

import {LocationChangeHistoryWithRouteParam, ThunkApi} from '../interfaces'

import navigateToRoute from './navigateToRoute'

type NavigateToOrderDetailParam = LocationChangeHistoryWithRouteParam & {
    /** 주문 번호 */
    orderNo: string
    /** 예외 메시지 */
    message?: string
}

/**
 * 주문상세 페이지로 이동
 * - Route 로의 이동 기능을 제공합니다. (routeBased: true)
 */
export const navigateToOrderDetail = createAsyncThunk<void, NavigateToOrderDetailParam, ThunkApi>(
    'navigateTo/orderDetail',
    async ({historyType = 'PUSH', orderNo, message, routeBased = false}, {dispatch}) => {
        if (message) {
            browserAlert({message})
        }

        if (routeBased) {
            dispatch(navigateToRoute({historyType, path: ROUTER_ORDER_DETAIL.MAIN.getPath(`/${orderNo}`)}))
        } else {
            changeBrowserLocation({
                type: historyType,
                url: ROUTER_ORDER_DETAIL.MAIN.getHref(`/${orderNo}`),
            })
        }

        return Promise.resolve()
    },
)

export default navigateToOrderDetail
